import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserMd, FaClinicMedical, FaUserNurse } from 'react-icons/fa';
import HeroSection from '../../components/HeroSection';
import doctorImage from '../../images/doctor.jpg';
import '../../style/lekarze.css';

const DlaLekarzy = () => {
  const navigate = useNavigate();

  const handleContactClick = () => navigate('/kontakt');

  const sections = [
    {
      title: 'Pakiety dla lekarzy',
      icon: <FaUserMd className="section-icon" />,
      items: [
        'Ubezpieczenia OC obowiązkowe i dobrowolne',
        'Ubezpieczenie przychodów dla zatrudnionych na kontrakcie',
        'Ubezpieczenie na życie dla lekarzy',
        'Ubezpieczenie gabinetu (praktyki lekarskiej)',
        'Ochrona w przypadku zakażenia HIV i WZW podczas pracy',
        'Ubezpieczenie domu lub mieszkania',
        'Ubezpieczenie turystyczne',
        'Ubezpieczenie następstw nieszczęśliwych wypadków',
        'Ubezpieczenie zabiegów medycyny estetycznej',
        'Ubezpieczenie ochrony prawnej z usługą asysty prawnej',
      ],
    },
    {
      title: 'Pakiety dla podmiotów leczniczych',
      icon: <FaClinicMedical className="section-icon" />,
      items: [
        'Ubezpieczenie OC dla podmiotów leczniczych',
        'Grupowe ubezpieczenie na życie',
        'Ubezpieczenie na życie dla lekarzy',
        'Ubezpieczenie majątku podmiotów leczniczych wykonujących działaność leczniczą wraz z całym sprzętem medycznym',
        'Ubezpieczenie ochrony prawnej z asystą',
      ],
    },
    {
      title: 'Pakiety dla pielęgniarek i położnych',
      icon: <FaUserNurse className="section-icon" />,
      items: [
        'Ubezpieczenia OC obowiązkowe i dobrowolne',
        'Ochrona w przypadku zakażenia HIV i WZW',
        'Ubezpieczenie przychodów dla kontraktowych',
        'Ubezpieczenie na życie',
        'Ubezpieczenie gabinetu (praktyki pielęgniarskiej)',
        'Ubezpieczenie domu lub mieszkania',
        'Ubezpieczenie turystyczne',
        'Ubezpieczenie następstw nieszczęśliwych wypadków',
        'Ochrona prawna z usługą asysty',
      ],
    },
  ];

  return (
    <>
      <HeroSection
        image={doctorImage}
        text="Nowoczesne ubezpieczenia dla branży medycznej"
      />

      <section className="wow-section">
        <h2 className="section-title">Kompleksowa ochrona dla medyków</h2>
        <p className="section-subtitle">
          Sprawdź nasze dedykowane pakiety ubezpieczeń – stworzone z myślą o lekarzach, pielęgniarkach i placówkach medycznych.
        </p>

        <div className="cards-grid">
          {sections.map((section, idx) => (
            <div className="glass-card" key={idx}>
              {section.icon}
              <h3>{section.title}</h3>
              <ul>
                {section.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="cta-container">
          <button onClick={handleContactClick} className="cta-button">
            Skontaktuj się z nami
          </button>
        </div>
      </section>
    </>
  );
};

export default DlaLekarzy;
